import { useRef } from "react";
import { Button, Icon } from "@simplybusiness/mobius";
import type { TradeOption } from "@simplybusiness/mobius-trade-selector";
import { TradeSelector } from "@simplybusiness/mobius-trade-selector";
import { rightArrow } from "@simplybusiness/icons";
import type { Site, Vertical } from "../../../../types";

type TradeSelectionProps = {
  vertical: Vertical;
  site: Site;
  setSelectedTrade: (trade: TradeOption) => void;
  setCTAPressed: (pressed: boolean) => void;
  fireEvent: (action: string) => void;
};

export const TradeSelection = ({
  vertical,
  site,
  setSelectedTrade,
  setCTAPressed,
  fireEvent,
}: TradeSelectionProps) => {
  const selectedTradeRef = useRef<boolean>(false);

  return (
    <>
      <div className="mobius-interventions__coverage-diagnosis-trade-selector">
        <TradeSelector
          label="What is your trade or profession?"
          site={site}
          vertical={vertical}
          variant="default"
          onSelectTrade={(trade: TradeOption) => {
            selectedTradeRef.current = true;
            fireEvent("cd_trade_selected");
            setSelectedTrade(trade);
          }}
        />
      </div>
      <Button
        className="mobius-interventions__coverage-diagnosis-dynamic-content-cta"
        size="sm"
        data-testid="coverage-diagnosis-see-covers"
        onPress={() => {
          if (selectedTradeRef.current) {
            fireEvent("cd_see_covers");
            setCTAPressed(true);
          }
        }}
      >
        See Covers&nbsp;&nbsp;
        <Icon size="sm" icon={rightArrow}></Icon>
      </Button>
    </>
  );
};
